module.exports = __webpack_public_path__ + "img/icon-work.2150289b.svg";